// istanbul ignore file

import { PropertyKeyInformation } from './property-key-information';

type Property = {
    compliancePropertyId: number;
    address: string;
    addressLine1: string;
    addressLine2: string;
    compliancePropertyManagerId?: number;
    isIntegrated?: boolean;
};

enum PropertyContactType {
    PROPERTY_MANAGER = 'PROPERTY_MANAGER',
    LANDLORD = 'LANDLORD',
    AGENCY_CONTACT = 'AGENCY_CONTACT',
    OCCUPANT = 'OCCUPANT'
}

type LandlordContact = {
    address: string | null;
    email: string | null;
    contacts: {
        home: {
            number: string | null;
        };
        business: {
            number: string | null;
        };
        mobile: {
            number: string | null;
        };
    };
};

type PropertyContact = {
    name: string;
    email: string;
    type: PropertyContactType;
    position?: string;
} & LandlordContact;

type OneOffENRequestResponse = {
    success: boolean;
    message: string;
    successful: number;
    failures: number;
    report: Array<{
        reason: string;
        address: string;
    }>;
};

type UpdateAgencyKeys = {
    propertyManagerId?: string | number;
    isKeyAvailable?: boolean;
    keyNumber?: string | null;
    keyLocationId?: string | number | null;
};

type UpdatePropertyDetails = {
    propertyId: number;
    agencyKey?: UpdateAgencyKeys;
    propertyKey?: Omit<PropertyKeyInformation, 'validFrom'>;
};

enum PropertyKeyAvailableOnsite {
    AVAILABLE_ONSITE = 'AVAILABLE_ONSITE',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    TEMPORARILY_AVAILABLE = 'TEMPORARILY_AVAILABLE'
}

enum PropertyUtilityConnection {
    NONE = 'NONE',
    GAS_ONLY = 'GAS_ONLY',
    GAS_AND_ELECTRICITY = 'GAS_AND_ELECTRICITY',
    ELECTRICITY_ONLY = 'ELECTRICITY_ONLY'
}

type Coordinates = {
    latitude: number;
    longitude: number;
};

type Address = {
    firstHalf: string;
    secondHalf: string;
    full: string;
    number?: string | null;
    line1?: string | null;
    line2?: string | null;
    suburb?: string | null;
    state?: string | null;
    postcode?: string | null;
};

type BasicPropertyData = {
    id: number;
    address: Address;
    type: string | null;
    coordinates?: Coordinates;
    yearBuilt?: number | null;
    isAvailableToView: boolean;
    isEnrolled: boolean;
};

export {
    Property,
    PropertyContactType,
    LandlordContact,
    PropertyContact,
    OneOffENRequestResponse,
    UpdatePropertyDetails,
    PropertyKeyAvailableOnsite,
    PropertyUtilityConnection,
    BasicPropertyData,
};
